import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  type WritableSignal
} from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { NotificationCloseButtonComponent } from '../notification/notification-close-button.component';
import { NotificationComponent } from '../notification/notification.component';
import { SYSTEM_ERROR_CLOSE, type CloseSystemError } from './system-error.service';

/**
 * System Error Component - panel displayed at the bottom of the screen containing a generic error message
 */
@Component({
  selector: 'td-wb-system-error',
  templateUrl: './system-error.component.html',
  styleUrls: ['./system-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NotificationComponent,
    TranslateDirective,
    NotificationCloseButtonComponent
  ]
})
export class SystemErrorComponent {
  /**
   * Animation state
   */
  readonly animationState: WritableSignal<'enter' | 'exit'> = signal('enter');

  private readonly closeSystemError: CloseSystemError | null = inject(SYSTEM_ERROR_CLOSE, { optional: true });

  /**
   * Starts the dialog exit animation.
   */
  startExiting(event?: MouseEvent): void {
    if (event !== undefined) {
      event.preventDefault();
    }
    this.animationState.set('exit');
  }

  /**
   * Emit lifecycle events based on the CSS animation end.
   */
  onAnimationDone(event: AnimationEvent): void {
    if (event.target !== event.currentTarget) {
      return;
    }
    if (this.animationState() === 'exit' && event.animationName.includes('system-error-exit')) {
      this.close();
    }
  }

  private close(): void {
    if (this.closeSystemError !== null && this.closeSystemError !== undefined) {
      this.closeSystemError();
    }
  }
}
